import classNames from 'classnames';
import React from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../components/modal/components/modal-restricted/withRestrictedModal';
import { withUser } from '../../user/UserContext';
import { UserContextType } from '../../user/user.types';
import styles from './decision_header_title.module.scss';
import { ExcerptCount } from '../../components/excerpt/Excerpt';

type Props = {
  decision: any;
  index: number;
  source: string;
  otherParams?: { [s: string]: string } | null;
  onDecisionTitleClicked?: Function | null;
} & WithRestrictedModalProps &
  UserContextType;

type State = {
  visited: boolean;
};

export class RawDecisionHeaderTitle extends React.Component<Props, State> {
  static defaultProps = {
    otherParams: null,
    onDecisionTitleClicked: null,
  };

  state: State = { visited: false };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    return {
      ...prevState,
      ...nextProps,
      visited: nextProps.decision.visited,
    };
  }

  onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const {
      accessPremium,
      source,
      openRestrictedModal,
      onDecisionTitleClicked,
    } = this.props;

    if (accessPremium) {
      if (onDecisionTitleClicked) {
        onDecisionTitleClicked(event);
      }
      this.setState({ visited: true });
    } else {
      openRestrictedModal(source);
    }
  };

  getDecisionUrl = () => {
    const { decision, source, otherParams } = this.props;
    const sourceParameters = { source };
    return buildUrlWithParameters(
      decision.url,
      otherParams ? { ...sourceParameters, ...otherParams } : sourceParameters,
    );
  };

  render() {
    const { decision, index, accessPremium } = this.props;
    const { visited } = this.state;
    return (
      <div className={styles.container}>
        {decision.position && <ExcerptCount>{decision.position}</ExcerptCount>}
        <Hyperlink
          className={classNames(styles.title, visited && styles.visited)}
          id={`excerpt_title_${index}`}
          dangerouslySetInnerHTML={{ __html: decision.titre }}
          onClick={this.onClick}
          {...(accessPremium ? { href: this.getDecisionUrl() } : {})}
        />
      </div>
    );
  }
}

export const DecisionHeaderTitle = withUser(
  withRestrictedModal(RawDecisionHeaderTitle),
);
